module.exports = __webpack_public_path__ + "img/staffing2_mini.6168c3dc.png";